import { createAction } from 'typesafe-actions';
import { ACTIONS, BetSlotType, IBets, IConfirmedBet } from './types';

export const placeBetAction = createAction(ACTIONS.PLACE_BET)<BetSlotType>();

export const updatePlacedBetsAction = createAction(ACTIONS.UPDATE_PLACED_BETS)<IBets>();

export const clearAllBetsAction = createAction(ACTIONS.CLEAR_ALL_BETS)();

export const addConfirmedBetAction = createAction(ACTIONS.ADD_CONFIRMED_BET)<IConfirmedBet[]>();

export const setConfirmedBetAction = createAction(ACTIONS.SET_CONFIRMED_BET)<IConfirmedBet[]>();

export const cancelAllBetsAction = createAction(ACTIONS.CANCEL_ALL_BETS)();

export const cancelLastBetAction = createAction(ACTIONS.CANCEL_LAST_BET)();
